import {client} from './client';

class objectOwnersApi {
    static async all() {
        let result = await client.get('/object_owners');
        return result.data;
    }

    static async list(params) {
        let response = await client.get('/object_owners/list', {params});
        return response.data;
    }

    static async show(id) {
        let response = await client.get('/object_owners/' + id);
        return response.data;
    }

    static async create(model) {
        let response = await client.post('/object_owners', model);
        return response.data;
    }

    static async update(model) {
        let response = await client.patch('/object_owners/' + model.id, model);
        return response.data;
    }

    static async delete(id) {
        let response = await client.delete('/object_owners/' + id);
        return response.data;
    }
}

export default objectOwnersApi;
